import { createContext, useContext, useMemo, useState } from 'react';
// @ts-expect-error TS2554: Expected 1 arguments, but got 0.
const ConsumerNameContext = createContext();

function useAggregatorConsumerName() {
    const context = useContext(ConsumerNameContext);
    if (!context) {
        throw new Error(`useConsumerName must be used within a ConsumerNameProvider`);
    }
    return context;
}

function AggregatorConsumerNameProvider(props: any) {
    const [aggregatorConsumerName, setAggregatorConsumerName] = useState('');
    const value = useMemo(() => [aggregatorConsumerName, setAggregatorConsumerName], [aggregatorConsumerName]);
    return <ConsumerNameContext.Provider value={value} {...props} />;
}

export { AggregatorConsumerNameProvider, useAggregatorConsumerName };
